import Reflux from 'reflux';
import { DashboardActions, AppActions, CourseActions } from 'actions';
import SteelCompass from 'services/SteelCompass';
import CourseService from 'services/Course';

var id = -1;

var DashboardStore = Reflux.createStore({
  listenables: [DashboardActions, CourseActions],
  data: {
    courses: [],
    loading: false
  },
  getInitialState() {
    return this.data;
  },
  onRead(callback) {
    this.data = {
      ...this.data,
      loading: true
    };
    this.trigger(this.data);
    return SteelCompass.call(
      'dashboard',
      'read',
      { sortBy: 'lastVisit' },
      response => {
        this.data = {
          ...this.data,
          courses: response.data || [],
          loading: false
        };
        this.trigger(this.data);
        DashboardActions.readComplete();
        if (callback) {
          callback();
        }
      }
    );
  },
  setSortMethod(sortMethod) {
    this.data = {
      ...this.data,
      sortMethod
    };
    this.resort();
  },
  resort() {
    const sortMethod = `sortBy${this.data.sortMethod}`;
    this[sortMethod] && this[sortMethod]();
  },
  sort(sorterFunc) {
    const courses = this.data.courses.slice();

    courses.sort(sorterFunc);
    this.data = {
      ...this.data,
      courses
    };
    this.trigger(this.data);
  },
  sortByLastVisit() {
    this.sort((a, b) => {
      if (a.lastVisit < b.lastVisit) {
        return 1;
      }
      if (a.lastVisit > b.lastVisit) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
  },
  sortByCreated() {
    this.sort((a, b) => {
      if (a.created < b.created) {
        return 1;
      }
      if (a.created > b.created) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
  },
  onDuplicateCourse(course) {
    return SteelCompass.request('course', 'duplicate', { id: course.id }).then(
      duplicate => {
        DashboardActions.duplicateCourseComplete(duplicate);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onDuplicateCourseComplete(duplicate) {
    this.data.courses.unshift(duplicate);
    duplicate.mode = 'edit';
    this.trigger(this.data);
  },
  addCourseSkeleton(name) {
    id = id - 1;
    const courses = this.data.courses.slice();
    courses.unshift({
      id,
      mode: 'edit',
      name,
      coverImage: { id: 0 },
      skeleton: true
    });
    this.data = {
      ...this.data,
      courses
    };
    this.trigger(this.data);
  },
  saveCourse(course) {
    const action = course.id > 0 ? 'update' : 'create';
    const courseId = course.id;
    if (action === 'create') {
      delete course.id;
      course.settings = {};
    }

    return SteelCompass.request('course', action, course)
      .then(response => {
        if (action === 'update') {
          return DashboardActions.updateCourseComplete(response);
        } else {
          DashboardActions.createCourseComplete(courseId, response);
        }
      })
      .catch(error => {
        AppActions.genericError(error);
      });
  },
  initQuizSection(course,enabled) {
    DashboardActions.createCourseComplete(course.id, course);
    CourseService.addSection(course.id, 'Quiz', 'quiz').then(res => {
      CourseActions.addQuizSectionComplete({...res, type: 'quiz'}, null)
      return CourseService.addPage(res.id, 'Quiz 1', 'quiz')
        .then(pageRes => {
          const oldSettings = course.settings || {};
          const id = course.id;
          const pageId = pageRes.id;
          const settings = {
            ...oldSettings,
            quiz: {
              enabled,
              pages: {
                [pageId]: {
                  repeatable: false,
                  welcomeText: '',
                  descriptionText: '',
                  successText: '',
                  failText: '',
                  threshold: 80
                }
              }
            }
          };
          CourseActions.addQuizPageComplete(res.id, null, pageRes);
          CourseActions.updateQuizSettings(settings.quiz)
          return SteelCompass.request('course', 'update', { id, settings })
        });
    });
  },
  updateCourseComplete(updatedCourse) {
    const courses = this.data.courses.slice().map(course => {
      if (course.id === updatedCourse.id) {
        return updatedCourse;
      }
      return course;
    });

    this.data = {
      ...this.data,
      courses
    };
    this.trigger(this.data);
  },
  createCourseComplete(addedId, courseToAdd) {
    const courses = this.data.courses.slice().filter(course => {
      return course.id !== addedId;
    });
    courses.unshift(courseToAdd);
    this.data = {
      ...this.data,
      courses
    };
    this.trigger(this.data);
  },
  onRemoveCourse(course) {
    if (course.id > 1) {
      return SteelCompass.request('course', 'delete', course).then(() => {
        DashboardActions.removeCourseCompleted(course);
      });
    }
    DashboardActions.removeCourseCompleted(course);
  },
  removeCourseCompleted(course) {
    const courses = this.data.courses.slice();
    const index = courses.indexOf(course);
    if (index > -1) {
      courses.splice(index, 1);
      this.data.courses = courses;
      this.trigger(this.data);
    }
  }
});

export default DashboardStore;



// WEBPACK FOOTER //
// ./src/js/stores/Dashboard.js